import { Skeleton } from '@radix-ui/themes';
import { type ReactNode } from 'react';
import ExternalJobRef from '../elements/ExternalJobRef';

const PageHeader = (props: { className: string; children?: ReactNode }) => {
  return <div className={'header-row flex justify-between mx-0 p-2 ' + props.className}> {props.children}</div>;
};
export default PageHeader;

const Title = (props: { children?: ReactNode }) => {
  return <h1 className="m-0 p-0">{props.children}</h1>;
};

const Swiper = ({
  loading,
  job,
}: {
  loading: boolean;
  job: {
    title: string;
    company: string;
    location: { name: string; city: string; country: string };
    applications: { totalCount: number };
    externalRef: { externalId: string; source: string };
  };
}) => {
  const locationName = job.location?.name || job.location?.city || job.location?.country;

  if (loading) {
    return (
      <span className="my-auto">
        <h1 className="swiper-count ">
          <Skeleton width="3rem" height="3rem" />
        </h1>
        <span className="float-left">
          <h4 className="flex">
            Job - <Skeleton width="10rem" />
          </h4>
          <h3 className="float-left">
            <Skeleton width="20rem" />
          </h3>
        </span>
      </span>
    );
  }

  return (
    <span className={'my-auto items-center align-middle'}>
      <h1 className="swiper-count ">{job.applications.totalCount}</h1>
      <span className="float-left">
        <h4 className="flex flex-row items-center align-middle">
          {[job.company, locationName].filter(Boolean).join(' - ')}
          {job.externalRef?.externalId && (
            <div className="flex items-center align-middle">
              {' '}
              - <ExternalJobRef externalId={job.externalRef.externalId} source={job.externalRef.source} />
            </div>
          )}
        </h4>
        <h3 className="float-left">{job.title}</h3>
      </span>
    </span>
  );
};

const Buttons = (props: { children?: ReactNode }) => {
  if (props.children)
    return <span className="ml-auto my-auto flex flex-row items-center align-middle gap-1">{props.children}</span>;
  else return <span></span>;
};

PageHeader.Title = Title;
PageHeader.Swiper = Swiper;
PageHeader.Buttons = Buttons;
